import React from 'react'
import NavAdmin from '../Components/AdminNav/NavAdmin'
import AllUsersControl from '../Components/AllUser/AllUsersControl'

function AllUsers() {
  return (
    <div>
        <NavAdmin></NavAdmin>
        <AllUsersControl></AllUsersControl>
    </div>
  )
}

export default AllUsers